import React, { useEffect } from 'react';

const GoogleCallback = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    
    if (code && window.opener) {
      window.opener.postMessage({ type: 'google-code', code }, window.location.origin);
      window.close();
    } else if (code) {
      window.location.href = `/google-success?code=${code}`;
    }
  }, []);

  return (
    <div style={{
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }}>
      <div>Completing Google login, please wait...</div>
    </div>
  );
};

export default GoogleCallback;